import { useEffect, useState } from "react";
import { isEqual } from "lodash";
import { useSession } from "next-auth/react";

import { useAsyncEffect } from "@/hooks/useAsyncEffect";

import type { FunnelAnswers } from "../config";

/**
 * Hook to manage the funnel answers in the session context and local state.
 */
export function useFunnelAnswers() {
  const { status, data: session, update: updateSession } = useSession();
  const [funnelAnswers, setFunnelAnswers] = useState<FunnelAnswers>(
    session?.context?.funnelData ?? {},
  );

  useAsyncEffect(async () => {
    if (!isEqual(session?.context?.funnelData, funnelAnswers)) {
      await updateSession({ funnelData: funnelAnswers });
    }
  }, [funnelAnswers]);

  useEffect(() => {
    if (
      status === "loading" ||
      !session ||
      isEqual(session.context.funnelData, funnelAnswers)
    )
      return;
    setFunnelAnswers(session.context.funnelData);
  }, [status, session]);

  return { funnelAnswers, setFunnelAnswers };
}
